import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Radio } from './radio';

export class RadioGroup extends React.PureComponent {
  // for now eslint-plugin-react doesn't recognize `getDerivedStateFromProps`
  // which is introduced in React 16.3
  static propTypes = {
    checked: PropTypes.any, // eslint-disable-line
    disabled: PropTypes.bool,
    getItemId: PropTypes.func,
    getItemValue: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.any).isRequired,
    name: PropTypes.string, // eslint-disable-line
    onChange: PropTypes.func.isRequired,
    renderItem: PropTypes.func,
  }

  static defaultProps = {
    checked: null,
    disabled: false,
    getItemId: (item, index) => String(index),
    getItemValue: null,
    name: null,
    renderItem: () => null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      name: nextProps.name || prevState.name || _.uniqueId('radio-group-'),
    };
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const getItemValue = this.props.getItemValue || this.props.getItemId;

    return (
      <React.Fragment>
        {this.props.items.map((item, index) => {
          const id = this.props.getItemId(item, index);
          const itemDisabled = item.disabled;
          const onChange = () => {
            this.props.onChange(item);
          };

          return (
            <Radio
              key={id}
              id={`${this.state.name}-${id}`}
              checked={this.props.checked === item}
              disabled={itemDisabled || this.props.disabled}
              name={this.state.name}
              onChange={onChange}
              value={getItemValue(item, index)}
            >
              {this.props.renderItem(item, index)}
            </Radio>
          );
        })}
      </React.Fragment>
    );
  }
}
